/* eslint-disable react-hooks/exhaustive-deps */
import {
	ApButtonDanger,
	ApButtonSecondary,
	colors,
} from '@alixpartners/ui-components';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	GridContainer,
	GridItem,
	Header,
	HeaderSpan,
	RefreshSpan,
	TableFilterHeader,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import EditWorkShopData from 'SpendController/Components/Modal/EditWorkShopData';
import Modal from 'SpendController/Components/Modal/Modal';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import { spendFormatter } from 'SpendController/number';
import {
	BASELINE_KPI_DATA,
	GL_HEADER,
	GL_REFRESH_HEADER,
	PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
	PREWORKSHOP_KPI_DATA,
	SAVINGS_SIGNS_OFF_KPI_DATA,
	convertToPercentage,
	extractSelectedArrays,
	formatPreWorkShopKpiData,
	keyMapping,
	updateSavingsData,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import {
	deleteSpendControllerData,
	getBaselineSummaryKpis,
	getPreWorkShopSummaryKpis,
	getSavingSignOffSummaryKpis,
	updateWorkshopId,
} from 'utils/apiRequests';

const healthBars = [
	`Baseline Health Bar`,
	`PreWorkShop Health Bar`,
	`Savings Sign Off Health Bar`,
];

function Baseline(props) {
	const [baselineKpiData, setBaseLineKpiData] = useState(BASELINE_KPI_DATA);
	const [preWorkShopKpiData, setPreWorkShopKpiData] = useState(
		PREWORKSHOP_KPI_DATA
	);
	const [savingsSignoffKpiData, setSavingsSignoffKpiData] = useState(
		SAVINGS_SIGNS_OFF_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const [isTutorialOpen, setIsTutorialOpen] = useState(false);
	const [showSidebar, setShowSideBar] = useState(false);
	const [selectedSpendType, setSelectedSpendType] = useState([
		'MICRO',
		'MACRO',
	]);
	const [selectedKPI, setSelectedKPI] = useState(0);
	const [reFresh, setrefresh] = useState(false);
	const [gridApi, setGridApi] = useState(null);
	const steps = [
		{
			selector: '[data-tour="baseline-kpi-step-1"]',
			content:
				'This displays the total spend in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-2"]',
			content:
				'This displays the distinct spend owners in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-3"] ',
			content:
				'This displays the unique supplier count in the dataset and dynamically updates based on the applied filters.',
		},
		{
			selector: '[data-tour="baseline-kpi-step-4"]',
			content:
				'This displays the unique spend owner and vendor name combination in the dataset and dynamically updates based on the applied filters.',
		},
		// Add more steps as needed
	];
	const {
		filters,
		baselineColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		setUploadRefresh,
		uploadRefresh,
		workshopState,
		setWorkshopState,
		setSpendType,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[
			filters.stack_1[0].options,
			filters.stack_1[1].options,
			filters,
			filterModelData,
			selectedSpendType,
		]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			setSpendType(selectedSpendType);
		},
		[selectedSpendType]
	);

	const handleKpiData = async (filters, realTime = false) => {
		realTime && setIsLoading(true);
		const tempFilters = extractSelectedArrays(filters);
		tempFilters.tailSpendType = selectedSpendType;
		const baselineKpiResponse = await getBaselineSummaryKpis(tempFilters);
		const preWorkshopKpiResponse = await getPreWorkShopSummaryKpis(tempFilters);
		let baselineKpiKeys = Object.keys(baselineKpiResponse.data);
		let newBaselineKpiData = baselineKpiData;
		for (let i = 0; i < baselineKpiKeys.length; i++) {
			newBaselineKpiData.data[i].value = newBaselineKpiData.data[i].isCurrency
				? spendFormatter(baselineKpiResponse.data[baselineKpiKeys[i]])
				: baselineKpiResponse.data[baselineKpiKeys[i]];
		}
		setBaseLineKpiData(newBaselineKpiData);
		let temppreWorkshopKpiData = formatPreWorkShopKpiData(
			preWorkshopKpiResponse.data
		);
		let preWorkshopKpiKeys = Object.keys(temppreWorkshopKpiData);
		let newWorkShopKpiData = preWorkShopKpiData;
		for (let i = 0; i < preWorkshopKpiKeys.length; i++) {
			newWorkShopKpiData.data[i].value = newWorkShopKpiData.data[i].isCurrency
				? spendFormatter(temppreWorkshopKpiData[preWorkshopKpiKeys[i]])
				: newWorkShopKpiData.data[i].isPercent
					? convertToPercentage(
							temppreWorkshopKpiData[preWorkshopKpiKeys[i]],
							1
					  )
					: temppreWorkshopKpiData[preWorkshopKpiKeys[i]];
		}

		setPreWorkShopKpiData(newWorkShopKpiData);
		const savingsSignoffKpiDataResponse = await getSavingSignOffSummaryKpis(
			tempFilters
		);
		const tempPreWorkShopBaselineKpiData = updateSavingsData(
			savingsSignoffKpiDataResponse,
			savingsSignoffKpiData.data,
			keyMapping
		);
		setSavingsSignoffKpiData({
			...savingsSignoffKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	const updateWorkShopData = async (updatedWorkshop, editedData) => {
		await updateWorkshopId(updatedWorkshop);
		setWorkshopState(editedData);
	};
	const handleSpendTypeChange = async value => {
		setSelectedSpendType(value);
	};
	const handleClick = index => {
		setSelectedKPI(index);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<GridContainer>
					{healthBars.map((name, index) => (
						<GridItem
							key={index}
							selected={selectedKPI === index}
							onClick={() => handleClick(index)}
						>
							{name}
						</GridItem>
					))}
				</GridContainer>
				<div style={{ display: 'flex', padding: '1%' }}>
					<ApButtonSecondary
						onClick={() => {
							setUploadRefresh(state => !state);
							setrefresh(state => !state);
							// setRefresh(state=>!state)
						}}
						small
						style={{ marginTop: '5px' }}
					>
						Refresh/Save
					</ApButtonSecondary>
					<ApButtonSecondary
						iconName="settings"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={() => setShowSideBar(prev => !prev)}
						style={{ margin: '1% 0.8% 0 0 ', border: 'none' }}
						small
					>
						Workshop settings
					</ApButtonSecondary>
				</div>
			</div>
			{selectedKPI === 0 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary
						{...baselineKpiData}
						isTutorialOpen={isTutorialOpen}
						setIsTutorialOpen={setIsTutorialOpen}
						steps={steps}
					/>
				</div>
			)}
			{selectedKPI === 1 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary {...preWorkShopKpiData} />
				</div>
			)}
			{selectedKPI === 2 && (
				<div style={{ display: 'flex', padding: '0px 0 0 10px' }}>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[0],
							savingsSignoffKpiData.data[1],
						]}
					/>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[2],
							savingsSignoffKpiData.data[3],
						]}
						title={PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE}
					/>
				</div>
			)}

			<ColumnContainer>
				<Header>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableFilterHeader>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<BreakDownFilters
						location={props.location}
						selectedSpendType={selectedSpendType}
						handleSpendTypeChange={handleSpendTypeChange}
						gridApi={gridApi}
					/>
				</TableFilterHeader>
				<TableWrapper n={5}>
					<TableView
						data={baselineColumnDefs}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						uploadRefresh={uploadRefresh}
						selectedSpendType={selectedSpendType}
						workshopState={workshopState}
						refresh={reFresh}
						gridApi={gridApi}
						setGridApi={setGridApi}
					/>
				</TableWrapper>
			</ColumnContainer>
			{showSidebar && (
				<Modal
					heading="Workshop settings"
					show={showSidebar}
					handleClose={() => setShowSideBar(false)}
				>
					<EditWorkShopData
						onClose={setShowSideBar}
						data={workshopState}
						updateWorkShopData={updateWorkShopData}
					/>
				</Modal>
			)}
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					paddingRight: '20px',
				}}
			>
				<ApButtonDanger
					iconName="delete_outline"
					onClick={async () => {
						await deleteSpendControllerData();
						setUploadRefresh(state => !state);
					}}
				>
					Delete all data rows
				</ApButtonDanger>
			</div>
		</Container>
	);
}

export default Baseline;
